export default [{
    name: 'Для грузового транспорта',
    key: 'cargo',
}, {
    name: 'Для легковесного транспорта',
    key: 'passenger',
}];
